import Vue from 'vue';
import { Client, UpdatePorterCommandArguments, GetPorterViewModel, PorterKey, IPorterViewModel, GenericFieldDescription } from 'Api/CoreApi';
import ABaseComponent from 'Components/Base/ABaseComponent';
import { Prop, Component } from 'vue-property-decorator';
import ApiProvider from 'Api/ApiProvider';
import  PorterValidation  from '../PorterValidation/PorterValidation';
@Component({validations:PorterValidation})
export class PorterEditComponent extends ABaseComponent {
    @Prop()
    porterId: string;

    @Prop()
    public customerUsesFunctions: boolean;

    public functionCodes: string[] = [];
    public selectedFunctionCode: string = "";

    public viewModelFields: GenericFieldDescription[] =[];
    public porter : IPorterViewModel={};
    public saved: boolean = false; 

    async created() {
        await this.load();
    }

    async load() {
        this.setLoading();
        const client = ApiProvider.getApiClient();
        client.getPorterById(this.porterId)
            .then(data => {
                this.viewModelFields = data.fields;
                this.porter = data.porter;
                this.$v.$reset();
                this.selectedFunctionCode = this.porter.functionCode;

                if (this.customerUsesFunctions) {
                    client.getPorterFunction(this.porter.customerNumber)
                        .then(porterFunctionData => {
                            this.functionCodes = porterFunctionData.functions;
                            this.selectedFunctionCode = this.porter.functionCode;
                        });
                }

                //this.porter.genericFields = this.viewModelFields
                this.setLoaded();
            })
            .catch(e => {
                this.setError(e);
            });

        

    } 

    get requireEmail(): boolean {
        return ("Email" in this.porter.genericFields)
    }

    async save() {

        this.setLoading();

        let porterToSave = this.porter;
        
        const args = new UpdatePorterCommandArguments({
            firstName: porterToSave.firstName,
            lastName: porterToSave.lastName,
            functionCode: this.selectedFunctionCode,
            city: (this.porter.city) ? this.porter.city : "",
            street: (this.porter.street) ? this.porter.street : "",
            email: (this.porter.email) ? this.porter.email : "",
            key: new PorterKey({
                id: porterToSave.id
            }),
            genericFields: porterToSave.genericFields,
        });

        this.$v.$touch();

        if (!this.$v.$invalid) {
            const client = ApiProvider.getApiClient();
            client.updatePorter(args).then(result => {
                this.setLoaded();
                this.saved = true;
                alert("Saved");
            }).catch(e => {
                this.setError(e);
            });
        }
        this.setLoaded();
    }
}

Vue.component('porter-edit', PorterEditComponent);